<template>
    <v-container class="ma-0 pa-0 report-header">
        <v-row justify="space-around" class="report-row">
            <v-col cols="12" md="2">
                <report-card
                    :data="bookingReport.automaticBookingsPercentage"
                    :info-data="getAutomaticConfirmedAndCanceledPercentages()"
                    title="Reservas finalizadas automaticamente"
                />
            </v-col>
            <v-col cols="12" md="2">
                <report-card
                    :data="bookingReport.manualBookingsPercentage"
                    :info-data="getManualConfirmedAndCanceledPercentages()"
                    title="Reservas finalizadas manualmente"
                />
            </v-col>
            <v-col cols="12" md="2">
                <report-card
                    :data="bookingReport.canceledBookingsPercentage"
                    title="Reservas canceladas"
                />
            </v-col>
            <v-col cols="12" md="2">
                <report-card
                    :data="bookingReport.avgTimeWaitingToConfirm"
                    title="Tempo de espera médio da reserva confirmada"
                />
            </v-col>
            <v-col cols="12" md="2">
                <report-card
                    :data="bookingReport.totalBookings"
                    title="Reservas realizadas"
                />
            </v-col>
        </v-row>
        <v-row justify="space-around" class="report-row">
            <v-col cols="12" md="2">
                <report-card
                    :data="bookingReport.avgBookingDaysInAdvance"
                    title="Antecedência de realização da reserva"
                />
            </v-col>
            <v-col cols="12" md="2">
                <report-card
                    :data="bookingReport.avgBookedDays"
                    title="Diárias (média)"
                />
            </v-col>
            <v-col cols="12" md="2">
                <report-card
                    :data="bookingReport.avgDailyRate"
                    title="Valor da diária (média)"
                />
            </v-col>
            <v-col cols="12" md="2">
                <report-card
                    :data="bookingReport.avgTicket"
                    title="Ticket médio"
                />
            </v-col>
            <v-col cols="12" md="2">
                <report-card
                    :data="bookingReport.bookingsWithInvoicePercentage"
                    title="Reservas com nota fiscal"
                />
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
import ReportCard from "./BookingReportCard.vue";
export default {
    name: "ReportCards",

    components: {ReportCard},

    props: [
        "reportData"
    ],

    data: () => ({
        bookingReport: '',
    }),

    methods: {
        formatBookingData(data) {
            this.bookingReport = {
                automaticBookingsPercentage: this.formatPercentage(data.automaticBookingsPercentage),
                automaticConfirmedBookingsPercentage: this.formatPercentage(data.automaticConfirmedBookingsPercentage),
                automaticCanceledBookingsPercentage: this.formatPercentage(data.automaticCanceledBookingsPercentage),
                manualBookingsPercentage: this.formatPercentage(data.manualBookingsPercentage),
                manualConfirmedBookingsPercentage: this.formatPercentage(data.manualConfirmedBookingsPercentage),
                manualCanceledBookingsPercentage: this.formatPercentage(data.manualCanceledBookingsPercentage),
                canceledBookingsPercentage: this.formatPercentage(data.canceledBookingsPercentage),
                avgTimeWaitingToConfirm: this.formatHours(data.avgTimeWaitingToConfirm),
                totalBookings: data.total,
                avgBookingDaysInAdvance: this.formatDays(data.avgBookingDaysInAdvance),
                avgBookedDays: this.formatBookedDays(data.avgBookedDays),
                avgDailyRate: this.formatPrice(data.avgDailyRate),
                avgTicket: this.getAvgTicket(data.avgDailyRate, data.avgBookedDays),
                bookingsWithInvoicePercentage: this.formatPercentage(data.bookingsWithInvoicePercentage),
            }
        },

        formatPercentage(value) {
            if (value) {
                return parseFloat(value).toFixed(2) + '%';
            }
        },

        formatDays(value) {
            if (value) {
                return parseFloat(value).toFixed(1) + (value >= 2 ? ' dias' : ' dia');
            }
        },

        formatBookedDays(value) {
            if (value) {
                return parseFloat(value).toFixed(1) + (value >= 2 ? ' diárias' : ' diária');
            }
        },

        formatPrice(value) {
            if (value) {
                return 'R$ ' + (value / 100).toFixed(2);
            }
        },

        formatHours(value) {
            let hour = Math.floor(value / 60);
            let min = value % 60;
            if (value >= 60) {
                return `${parseInt(hour)}h ${parseInt(min)}min`;
            }
            return `${parseInt(min)}min`;
        },

        getAvgTicket(value, days) {
            if (value) {
                return this.formatPrice(parseFloat(value).toFixed(2) * parseFloat(days).toFixed(1));
            }
        },

        getAutomaticConfirmedAndCanceledPercentages() {
            return `Confirmadas = ${this.bookingReport.automaticConfirmedBookingsPercentage} | Canceladas = ${this.bookingReport.automaticCanceledBookingsPercentage}`;
        },

        getManualConfirmedAndCanceledPercentages() {
            return `Confirmadas = ${this.bookingReport.manualConfirmedBookingsPercentage} | Canceladas = ${this.bookingReport.manualCanceledBookingsPercentage}`;
        },
    },

    watch: {
        reportData(data) {
            this.formatBookingData(data)
        }
    }
}
</script>

<style scoped>
.report-row {
    min-height: 170px;
}
.report-header {
    max-width: 100%;
}
</style>
